import th from "./th";
const dictionary = (dict, word) => {
  let text = Object.keys(dict).length == 0 ? th[word] : dict[word];
  return text == "" ? th[word] : text ? text : "";
};
export default dictionary;
